import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Auth } from '@angular/fire/auth';

import { SocialSigninService } from '../../social-signin/social-signin.service';

@Component({
    standalone: false,
    selector: 'abs-reauth-prompt',
    template: `
        <div>
            <p>{{ 'GLOBAL.LOGIN.REAUTH.MESSAGE' | translate }}</p>
            <form *ngIf="primaryProviderId === 'password'" [formGroup]="passwordForm" (ngSubmit)="confirmWithPassword()">
                <div class="form-row">
                    <ion-label>{{ 'GLOBAL.LOGIN.PASSWORD' | translate }}</ion-label>
                    <ion-input type="password" formControlName="password"></ion-input>
                </div>
                <p class="error" *ngIf="error">{{ 'GLOBAL.ERRORS.' + error | translate }}</p>
                <div class="buttons">
                    <ion-button type="submit" [disabled]="passwordForm.invalid || submitting">
                        {{ 'GLOBAL.LOGIN.REAUTH.CONFIRM' | translate }}
                    </ion-button>
                </div>
            </form>
        </div>
    `
})
export class ReauthPromptComponent {
    @Output() reauthenticated = new EventEmitter<void>();

    submitting = false;
    error: string = null;

    passwordForm = this.fb.group({
        password: this.fb.control('', [Validators.required])
    });

    constructor(
        private fb: UntypedFormBuilder,
        private socialSignin: SocialSigninService,
        private auth: Auth
    ) {}

    get primaryProviderId(): string {
        return this.auth.currentUser?.providerData?.[0]?.providerId;
    }

    async confirmWithPassword() {
        if (this.passwordForm.invalid) {
            return;
        }

        this.error = null;
        this.submitting = true;

        const email = this.auth.currentUser?.providerData?.[0]?.email;

        try {
            await this.socialSignin.signInWithEmail(email, this.passwordForm.value.password);
            this.reauthenticated.emit();
        } catch (err: any) {
            this.error = err.code || 'UNKNOWN';
        } finally {
            this.submitting = false;
        }
    }
}
